export default {"src":"/_next/static/media/icone-aura.3d7fd9c5.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};